import React from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { selectOrganizations } from 'store/global'
import styles from './UserOrganization.scss'

export default function UserOrganization({ user }) {
  const allOrganizations = useSelector(selectOrganizations)

  const { organizationId } = user
  if (!organizationId) return null

  const userOrganization = allOrganizations.find(({ id }) => id === organizationId)

  if (!userOrganization) return null

  return <span className={styles.organization}>{userOrganization.name}</span>
}

UserOrganization.propTypes = {
  user: PropTypes.object.isRequired,
}
